/**
 * @author caijianjia
 * @date 2020/4/3 7:54 下午
 */
import {roles} from "./components/roles/roles";
const options = []
Object.entries(roles).map(v=>{
    v[1].map(q=>{
        options.push({key: q.type, value: q.name})
    })
})
export const fields = [
    {
        attr: 'type',
        "name": "单项选择",
        "value": "",
        "type": "RadioGroup",
        "props": {
            "rules": {
                "required": true,
                "message": "请选择"
            },
            "border": true
        },
        "options": [
            {
                "key": "1",
                "value": "智能配音"
            },
            {
                "key": "2",
                "value": "我要录制"
            },
            {
                "key": "3",
                "value": "导入配音"
            }
        ]
    },
    {
        "attr": "text",
        "name": "说话文本",
        "value": "",
        "type": "TextareaIcon",
        "props": {
            "placeholder": "多音字语音合成文本举例：\n音乐[yue4]家",
            "rules": {
                "required": false,
                "message": "请输入",
                "target": "blur"
            },
            "type": "textarea",
            "rows": "2"
        },
    },
    {
        attr: 'select',
        "name": "说话声音选择",
        "value": "",
        "type": "WordEditIcon",
        "props": {
            "placeholder": "请选择",
            "rules": {
                "required": true,
                "message": "请输入",
                "target": "blur"
            }
        },
        options
    },
    {
        attr: 'isShow',
        "name": "显示文本",
        "value": false,
        "type": "Switch",
        "props": {
            "rules": {
                "required": false,
                "message": "请选择"
            },
            "border": true
        },
        "options": [
            {
                "key": "1",
                "value": "显示文本"
            }
        ]
    },
    // {
    //     attr: 'img',
    //     "name": "文本框选择",
    //     "value": "",
    //     "type": "UploadSingleTencent",
    //     "props": {
    //         "rules": {
    //             "required": true,
    //             "message": "请选择",
    //             "target": "blur"
    //         }
    //     },
    //     "status": "1"
    // }
]
